import { createSelector } from '@ngrx/store';
import { AnnouncementState } from './announcement/announcement.reducer';
import { AuthState } from './auth/auth.reducer';
import { FeedbackState } from './feedback/feedback.reducer';
import { HouseholdState } from './household/households.reducer';
import { IngredientState } from './ingredient/ingredient.reducer';
import { LeftoverState } from './leftover/leftover.reducer';
import { MealPlannerState } from './meal-planner/meal-planner.reducer';
import { RecipeState } from './recipe/recipe.reducer';
import { ShoppingListState } from './shopping-list/shopping-list.reducer';
import { StorageState } from './storage/storage.reducer';
import { UserState } from './user/user.reducer';
import { selectisUserLoading } from './user/user.selectors';
import { selectIsLoadingHouseholds } from './household/households.selectors';
import { VersionState } from './version/version.reducer';
import { ImageState } from './image/image.reducer';
import { IngredientAssociationState } from './ingredient-association/ingredient-association.reducer';

export interface AppState {
  auth: AuthState;
  user: UserState;
  ingredients: IngredientState;
  leftovers: LeftoverState;
  storage: StorageState;
  shoppingList: ShoppingListState;
  household: HouseholdState;
  recipes: RecipeState;
  mealPlanner: MealPlannerState;
  feedback: FeedbackState;
  announcements: AnnouncementState;
  version: VersionState;
  image: ImageState;
  ingredientAssociations: IngredientAssociationState;
}

export const selectMainLayoutLoading = createSelector(
  selectisUserLoading,
  selectIsLoadingHouseholds,
  (isUserLoading, isHouseholdLoading) => isUserLoading || isHouseholdLoading
);

